import React from 'react';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { CampaignIndicator, AdIndicator } from 'widgets-v6/lifecycle-and-health-indicator';

export function IndicatorsDemo() {
    const log = (e, ctx) => console.log('clicked:', ctx);

    return (
        <Stack spacing={3} sx={{ p: 3 }}>
            <Typography variant="h6">Campaign Status</Typography>
            <Stack direction="row" spacing={1}>
                <CampaignIndicator status="pending" />
                <CampaignIndicator status="started" />
                <CampaignIndicator status="ended" />
                <CampaignIndicator status="finalized" />
                <CampaignIndicator status="archived" />
                <CampaignIndicator status="locked" />
                <CampaignIndicator status="legacy" />
            </Stack>

            <Typography variant="h6">Campaign Health (Ended & Finalized)</Typography>
            <Stack direction="row" spacing={1}>
                <CampaignIndicator status="ended" health="delivered_100" showHealth onClick={log} />
                <CampaignIndicator
                    status="ended"
                    health="delivered_lt_100"
                    showHealth
                    onClick={log}
                />
                <CampaignIndicator
                    status="finalized"
                    health="delivered_100"
                    showHealth
                    onClick={log}
                />
                <CampaignIndicator
                    status="finalized"
                    health="delivered_lt_100"
                    showHealth
                    onClick={log}
                />
            </Stack>

            <Divider />

            <Typography variant="h6">Ads — Synced when Campaign ≠ Started</Typography>
            <Stack direction="row" spacing={1}>
                {/* Campaign finalized -> ads visually finalized regardless of ad status prop */}
                <AdIndicator status="finalized" />
                <AdIndicator status="locked" />
                <AdIndicator status="legacy" />
            </Stack>

            <Typography variant="h6">Ads — Individual statuses when Campaign = Started</Typography>
            <Stack direction="row" spacing={1}>
                <AdIndicator status="pending" />
                <AdIndicator status="started" />
                <AdIndicator status="ended" />
                <AdIndicator status="archived" />
            </Stack>

            <Typography variant="h6">Ads Health (Ended & Finalized allowed)</Typography>
            <Stack direction="row" spacing={1}>
                <AdIndicator status="ended" health="delivered_100" showHealth onClick={log} />
                <AdIndicator status="ended" health="delivered_lt_100" showHealth onClick={log} />
                <AdIndicator status="finalized" health="delivered_100" showHealth onClick={log} />
                <AdIndicator
                    status="finalized"
                    health="delivered_lt_100"
                    showHealth
                    onClick={log}
                />
            </Stack>
        </Stack>
    );
}

export default IndicatorsDemo;
